(function () {
    var LOG_PREFIX = '[aco-labeller]';

    // Match agb-priority-products.js: skip badges on PDP, drawers,
    // predictive search, header, footer, dialog, aside.
    var CARD_EXCLUDE_ANCESTORS = 'cart-drawer, predictive-search, header, footer, dialog, [role="dialog"], aside';

    var FALLBACK_CACHE_KEY = '__acoLabellerConfig:v1';
    var FALLBACK_CACHE_TTL_MS = 5 * 60 * 1000;
    var _ownFetchInFlight = false;

    function _baseUrlForOwnFetch() {
        var raw = (typeof window !== 'undefined' && window.SE_CONFIG_URL) || '';
        if (!raw) return null;
        var m = raw.match(/^(.*)\/api\/[^/]+$/);
        if (m && m[1]) return m[1];
        return raw.replace(/\/+$/, '');
    }

    function _detectEnvFromTheme() {
        try {
            var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
            if (role && role !== 'main') return 'preview';
        } catch (e) {}
        return 'live';
    }

    // Diagnostics/info print on PREVIEW only — never on live (no console noise,
    // no exposing the onSale / compare-at logic to shoppers). Also honors the
    // panel's dev-logs category toggle: window.__AGB_consoleCategories.aco —
    // undefined = on (default), explicit false = silenced (same convention as
    // the other log categories). Genuine errors still use console.warn directly.
    function _dbg() {
        try {
            if (_detectEnvFromTheme() !== 'preview') return;
            var cats = window.__AGB_consoleCategories;
            if (cats && typeof cats === 'object' && cats.aco === false) return;
            console.log.apply(console, arguments);
        } catch (e) {}
    }

    function _readCachedOwnConfig() {
        try {
            var raw = sessionStorage.getItem(FALLBACK_CACHE_KEY);
            if (!raw) return null;
            var parsed = JSON.parse(raw);
            if (!parsed || typeof parsed !== 'object') return null;
            if (typeof parsed.at !== 'number') return null;
            if (Date.now() - parsed.at > FALLBACK_CACHE_TTL_MS) return null;
            return parsed.cfg || null;
        } catch (e) { return null; }
    }
    function _writeCachedOwnConfig(cfg) {
        try {
            sessionStorage.setItem(FALLBACK_CACHE_KEY, JSON.stringify({ at: Date.now(), cfg: cfg }));
        } catch (e) {}
    }

    function _stashOnEngine(cfg) {
        // Mirror onto SE_Engine.config.acoLabeller so the poll loop's
        // next _config() call returns truthy and the tick loop exits
        // cleanly. Without this, the cached-cfg path keeps the poll
        // running until maxTries and triggers the "giving up" warn
        // even though _apply() already ran via the .then() callback.
        try {
            if (window.SE_Engine && !window.SE_Engine.config) window.SE_Engine.config = {};
            if (window.SE_Engine && window.SE_Engine.config) window.SE_Engine.config.acoLabeller = cfg;
        } catch (e) {}
    }

    async function _fetchOwnConfig() {
        if (_ownFetchInFlight) return null;
        var cached = _readCachedOwnConfig();
        if (cached) {
            // Normalize and stash so the next poll tick sees the config
            // and exits cleanly.
            if (!Array.isArray(cached.labels)) cached.labels = [];
            _stashOnEngine(cached);
            return cached;
        }
        var base = _baseUrlForOwnFetch();
        if (!base) {
            _dbg(LOG_PREFIX, 'no SE_CONFIG_URL set -- cannot fetch own config');
            return null;
        }
        var env = _detectEnvFromTheme();
        var url = base + '/api/aco-labeller-config' + (env === 'preview' ? '?env=preview' : '');
        _ownFetchInFlight = true;
        try {
            var res = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!res.ok) {
                console.warn(LOG_PREFIX, 'config fetch HTTP', res.status, 'from', url);
                return null;
            }
            var envelope = await res.json();
            // Tolerate "no labels configured yet" -- backend returns a valid
            // envelope but the labels array is missing or null. Treat as
            // empty list so the poll loop stops retrying. Empty labels =
            // no badges applied, which is the correct behavior for
            // "merchant hasn't set up any labels".
            var cfg = (envelope && envelope.config) || envelope || {};
            if (!cfg || typeof cfg !== 'object') {
                console.warn(LOG_PREFIX, 'config fetch returned non-object envelope', envelope);
                return null;
            }
            if (!Array.isArray(cfg.labels)) {
                _dbg(LOG_PREFIX, 'config envelope has no labels[] -- treating as empty', { keys: Object.keys(cfg) });
                cfg.labels = [];
            }
            _writeCachedOwnConfig(cfg);
            _stashOnEngine(cfg);
            _dbg(LOG_PREFIX, 'config fetched directly:', cfg.labels.length, 'label(s)', 'env=' + env);
            return cfg;
        } catch (e) {
            console.warn(LOG_PREFIX, 'config fetch failed:', e);
            return null;
        } finally {
            _ownFetchInFlight = false;
        }
    }

    function _config() {
        try {
            var c = window.SE_Engine && window.SE_Engine.config && window.SE_Engine.config.acoLabeller;
            if (!c || typeof c !== 'object') return null;
            // Tolerate engine config with missing/null labels: normalize to
            // empty array. Treats "engine knows the config block exists but
            // has no labels yet" as a valid config (just no badges to apply)
            // instead of an unresolved state that keeps the poll loop spinning.
            if (!Array.isArray(c.labels)) c.labels = [];
            return c;
        } catch (e) {}
        return null;
    }

    function _closestCard(el) {
        var card = el.closest('product-card');
        if (!card) return null;
        if (card.closest(CARD_EXCLUDE_ANCESTORS)) return null;
        return card;
    }

    function _allCards() {
        try {
            return Array.from(document.querySelectorAll('product-card'))
                .filter(function (c) { return !c.closest(CARD_EXCLUDE_ANCESTORS); });
        } catch (e) { return []; }
    }

    // ── DOM attribute readers ─────────────────────────────────────────
    // The Prestige theme emits a few useful data-* attrs on product-card
    // and its descendants; we read what we can and treat missing values
    // as "condition fails" so we never false-positive.

    function _cardTags(card) {
        var raw = card.getAttribute('data-product-tags')
            || card.getAttribute('data-tags')
            || (card.dataset && (card.dataset.productTags || card.dataset.tags))
            || '';
        if (!raw) return [];
        return String(raw).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    function _cardHandle(card) {
        var h = card.getAttribute('handle')
            || card.getAttribute('data-product-handle')
            || (card.dataset && card.dataset.productHandle);
        if (h) return h;
        // Fallback: parse from the product link.
        var link = card.querySelector('a[href*="/products/"]');
        if (!link) return null;
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        return m ? m[1] : null;
    }
    function _cardPrice(card) {
        // `product-card.liquid` emits `data-price` in cents on the
        // wrapping <product-card>; PDP synthesises the same attribute
        // from window.ShopifyProduct. Some legacy templates emit
        // dollars; we accept both and normalize to a number.
        var raw = card.getAttribute('data-price')
            || card.getAttribute('data-product-price')
            || (card.dataset && (card.dataset.price || card.dataset.productPrice));
        if (raw == null || raw === '') return null;
        var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
        if (!Number.isFinite(n)) return null;
        // Heuristic: values >= 1000 are almost certainly cents (Shopify's
        // money_in_cents). Divide by 100 so condition thresholds stay in
        // dollar terms.
        if (n >= 1000) n = n / 100;
        return n;
    }
    function _cardCompareAtPrice(card) {
        var raw = card.getAttribute('data-compare-at-price')
            || (card.dataset && card.dataset.compareAtPrice);
        if (raw == null || raw === '') return null;
        var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
        if (!Number.isFinite(n)) return null;
        if (n >= 1000) n = n / 100;
        return n;
    }
    function _cardInventory(card) {
        var raw = card.getAttribute('data-inventory')
            || card.getAttribute('data-real-stock')
            || (card.dataset && (card.dataset.inventory || card.dataset.realStock));
        if (raw == null || raw === '') return null;
        var n = parseInt(String(raw), 10);
        return Number.isFinite(n) ? n : null;
    }

    // ── Condition evaluator ───────────────────────────────────────────

    function _matchesTag(card, cond) {
        var tags = _cardTags(card);
        if (!tags.length || !cond.tags || !cond.tags.length) return false;
        var wanted = cond.tags.map(function (t) { return t.toLowerCase(); });
        var have = tags.map(function (t) { return t.toLowerCase(); });
        if (cond.match === 'all') {
            return wanted.every(function (t) { return have.indexOf(t) !== -1; });
        }
        return wanted.some(function (t) { return have.indexOf(t) !== -1; });
    }
    function _matchesCollection(_card, cond) {
        // Collection-handle condition is page-wide -- we're on the
        // collection page if window.__currentCollectionHandle is set.
        var handle = (window.__currentCollectionHandle || '').toLowerCase();
        if (!handle) return false;
        if (!cond.collectionHandles || !cond.collectionHandles.length) return false;
        var wanted = cond.collectionHandles.map(function (h) { return h.toLowerCase(); });
        return wanted.indexOf(handle) !== -1;
    }
    function _matchesPrice(card, cond) {
        var p = _cardPrice(card);
        if (p == null) return false;
        if (cond.op === 'lt') return cond.min != null && p < cond.min;
        if (cond.op === 'gt') return cond.min != null && p > cond.min;
        if (cond.op === 'between') {
            if (cond.min == null || cond.max == null) return false;
            return p >= cond.min && p <= cond.max;
        }
        return false;
    }
    function _matchesOnSale(card) {
        var p = _cardPrice(card);
        var cap = _cardCompareAtPrice(card);
        if (p == null || cap == null) return false;
        return cap > p;
    }
    function _matchesLowStock(card, cond) {
        var inv = _cardInventory(card);
        if (inv == null) return false;
        var t = Number.isFinite(cond.threshold) ? cond.threshold : 0;
        return inv <= t;
    }
    function _matchesSchedule(_card, cond) {
        var now = Date.now();
        if (cond.startUtc) {
            var s = new Date(cond.startUtc).getTime();
            if (Number.isFinite(s) && now < s) return false;
        }
        if (cond.endUtc) {
            var e = new Date(cond.endUtc).getTime();
            if (Number.isFinite(e) && now > e) return false;
        }
        return true;
    }
    function _matchesHandle(card, cond) {
        // Exact product-handle match. _cardHandle reads the <product-card handle>
        // attribute (or parses the /products/<handle> link). Empty list = no match
        // (use a label with NO conditions for "every product"), consistent with
        // _matchesTag. THIS WAS THE BUG: the switch below had no 'handle' case, so
        // every handle-scoped label silently failed (fell through to default ->
        // false). Tags worked because _matchesTag was wired; handle never was.
        if (!cond.productHandles || !cond.productHandles.length) return false;
        var h = (_cardHandle(card) || '').toLowerCase();
        if (!h) return false;
        var wanted = cond.productHandles.map(function (x) { return String(x || '').trim().toLowerCase(); });
        return wanted.indexOf(h) !== -1;
    }
    function _evalCondition(card, cond) {
        if (!cond || !cond.type) return false;
        switch (cond.type) {
            case 'tag':        return _matchesTag(card, cond);
            case 'collection': return _matchesCollection(card, cond);
            case 'price':      return _matchesPrice(card, cond);
            case 'onSale':     return _matchesOnSale(card);
            case 'lowStock':   return _matchesLowStock(card, cond);
            case 'schedule':   return _matchesSchedule(card, cond);
            case 'handle':     return _matchesHandle(card, cond);
            default:           return false;
        }
    }
    function _labelMatches(card, label) {
        if (!label.enabled) return false;
        // No conditions = always show when label is enabled.
        if (!Array.isArray(label.conditions) || !label.conditions.length) return true;
        return label.conditions.every(function (c) { return _evalCondition(card, c); });
    }

    // ── Badge stamping ────────────────────────────────────────────────

    function _badgeDataAttr(labelId) {
        return 'data-aco-label-' + String(labelId).replace(/[^a-z0-9-]/gi, '-').toLowerCase();
    }

    function _radiusForShape(shape) {
        if (shape === 'pill') return 999;
        if (shape === 'ribbon') return 3;
        return 4; // rectangle
    }

    function _buildBadgeSpan(label) {
        var span = document.createElement('span');
        span.className = 'badge aco-label';
        span.setAttribute(_badgeDataAttr(label.id), '1');
        // Inline style for full control over position + colors per-label.
        span.style.position = 'absolute';
        // Image badge: inline SVG (preferred) or raster URL fallback renders
        // AS the badge -- no text-pill chrome (padding/background/colour/etc).
        var hasSvg = typeof label.imageSvg === 'string' && label.imageSvg &&
            label.imageSvg.toLowerCase().indexOf('<script') === -1;
        var hasUrl = typeof label.imageUrl === 'string' && label.imageUrl;
        if (hasSvg || hasUrl) {
            var hpx = (Number.isFinite(label.imageHeightPx) && label.imageHeightPx > 0)
                ? label.imageHeightPx : 28;
            if (hasSvg) {
                span.innerHTML = label.imageSvg;
                var el = span.querySelector('svg');
                if (el) {
                    el.style.height = hpx + 'px';
                    el.style.width = 'auto';
                    el.style.display = 'block';
                    el.removeAttribute('width');
                    el.removeAttribute('height');
                }
            } else {
                var img = document.createElement('img');
                img.src = label.imageUrl;
                img.alt = label.text || label.name || '';
                img.style.height = hpx + 'px';
                img.style.width = 'auto';
                img.style.display = 'block';
                span.appendChild(img);
            }
            span.style.lineHeight = '0';
        } else {
            span.textContent = label.text || '';
            span.style.padding = '2px 8px';
            span.style.fontSize = '10px';
            span.style.fontWeight = '700';
            span.style.letterSpacing = '0.04em';
            span.style.textTransform = 'uppercase';
            span.style.background = label.backgroundColor || '#dc2626';
            span.style.color = label.textColor || '#ffffff';
            span.style.borderRadius = _radiusForShape(label.shape) + 'px';
            span.style.whiteSpace = 'nowrap';
        }
        span.style.pointerEvents = 'none';
        // Reset all edges so anchor changes after re-evaluation don't
        // leave a stale opposite-side value pinning the badge.
        span.style.top = span.style.bottom = span.style.left = span.style.right = '';
        var v = Number.isFinite(label.offsetVerticalRem)   ? label.offsetVerticalRem   : 0.25;
        var h = Number.isFinite(label.offsetHorizontalRem) ? label.offsetHorizontalRem : 0.25;
        var anchor = label.anchor || 'top-left';
        if (anchor === 'top-left')          { span.style.top    = v + 'rem'; span.style.left  = h + 'rem'; }
        else if (anchor === 'top-right')    { span.style.top    = v + 'rem'; span.style.right = h + 'rem'; }
        else if (anchor === 'bottom-left')  { span.style.bottom = v + 'rem'; span.style.left  = h + 'rem'; }
        else                                { span.style.bottom = v + 'rem'; span.style.right = h + 'rem'; }
        span.style.zIndex = String(Number.isFinite(label.zIndex) ? label.zIndex : 2);
        return span;
    }

    function _stampBadgeAt(host, label) {
        // Dedupe against host so re-runs don't double-stamp.
        if (host.querySelector('[' + _badgeDataAttr(label.id) + ']')) return false;
        // Absolute-positioned badge needs a non-static ancestor.
        var cs = window.getComputedStyle(host);
        if (cs && cs.position === 'static') host.style.position = 'relative';
        host.appendChild(_buildBadgeSpan(label));
        return true;
    }

    function _addBadge(card, label) {
        // Card path: anchor badge to the card's figure so it sits over the image.
        var host = card.querySelector('.product-card__figure') || card;
        return _stampBadgeAt(host, label);
    }

    // ── PDP support ───────────────────────────────────────────────────
    // The PDP has no <product-card> wrapper, but main-product.liquid
    // populates window.ShopifyProduct (via product-data-curated.liquid)
    // with every field the matchers need. We synthesize a detached
    // <product-card> carrying the same data-attrs the grid emits, run it
    // through the existing matchers, and stamp the badge over the
    // <product-gallery> image area.
    //
    // Snapshot semantics: the synthetic card reflects the
    // selected_or_first_available_variant at page load. Variant-picker
    // changes do NOT re-evaluate -- matches the "default variant" wording
    // in the control panel's onSale help text.

    function _synthPdpCard() {
        var p = window.ShopifyProduct;
        if (!p || typeof p !== 'object') return null;
        var v = null;
        if (Array.isArray(p.variants)) {
            for (var i = 0; i < p.variants.length; i++) {
                if (p.variants[i] && p.variants[i].available) { v = p.variants[i]; break; }
            }
            if (!v && p.variants.length) v = p.variants[0];
        }
        if (!v) v = { price: p.price, compare_at_price: p.compare_at_price };
        var card = document.createElement('product-card');
        if (p.handle) card.setAttribute('handle', String(p.handle));
        if (Array.isArray(p.tags) && p.tags.length) {
            card.setAttribute('data-product-tags', p.tags.join(','));
        }
        if (v.price != null) card.setAttribute('data-price', String(v.price));
        if (v.compare_at_price != null) card.setAttribute('data-compare-at-price', String(v.compare_at_price));
        if (v.displayed_qty != null) card.setAttribute('data-inventory', String(v.displayed_qty));
        return card;
    }

    function _pdpBadgeHost() {
        // Prefer the image-list viewport so the badge sits over the
        // visible picture, not the surrounding grid cell or thumbnails.
        var host = document.querySelector('product-gallery .product-gallery__image-list')
                || document.querySelector('product-gallery');
        if (!host) return null;
        if (host.closest && host.closest(CARD_EXCLUDE_ANCESTORS)) return null;
        return host;
    }

    function _isPdpUrl() {
        try {
            return !!(location && location.pathname && location.pathname.indexOf('/products/') !== -1);
        } catch (e) { return false; }
    }

    // One-shot diagnostic so the merchant can see, in the browser console,
    // exactly what the onSale evaluator read on this PDP and whether
    // cap > price held. Fires on any /products/ URL -- even when the
    // synthetic card couldn't be built -- so a missing ShopifyProduct
    // doesn't hide the diagnostic itself.
    var _pdpDiagLogged = false;
    function _logPdpOnSaleDiag(synth, labels) {
        if (_pdpDiagLogged) return;
        _pdpDiagLogged = true;
        var onSaleLabels = (labels || []).filter(function (l) {
            return l && l.enabled && Array.isArray(l.conditions)
                && l.conditions.some(function (c) { return c && c.type === 'onSale'; });
        }).map(function (l) { return { id: l.id, text: l.text }; });
        if (!synth) {
            console.log(
                LOG_PREFIX,
                'PDP onSale diagnostic: window.ShopifyProduct is not set on this page -- the labeller has no price/compare-at-price to read. Confirm this PDP uses main-product.liquid (or another section that renders product-data-curated.liquid).',
                {
                    pathname: (location && location.pathname) || null,
                    'window.ShopifyProduct': window.ShopifyProduct || null,
                    'onSale labels enabled': onSaleLabels.length ? onSaleLabels : '(none)'
                }
            );
            return;
        }
        var rawPrice = synth.getAttribute('data-price');
        var rawCap   = synth.getAttribute('data-compare-at-price');
        var price = _cardPrice(synth);
        var cap   = _cardCompareAtPrice(synth);
        var onSale = (price != null && cap != null) && cap > price;
        _dbg(LOG_PREFIX, 'PDP onSale diagnostic', {
            handle: synth.getAttribute('handle'),
            'data-price (raw, cents)': rawPrice === '' || rawPrice == null ? "''" : rawPrice,
            'data-compare-at-price (raw, cents)': rawCap === '' || rawCap == null ? "''" : rawCap,
            'price (parsed, $)': price,
            'compare_at_price (parsed, $)': cap,
            'onSale (cap > price)': onSale,
            'onSale labels enabled': onSaleLabels.length ? onSaleLabels : '(none)'
        });
    }

    // ── Orchestration ────────────────────────────────────────────────

    function _apply() {
        var cfg = _config();
        if (!cfg || cfg.enabled === false) return;
        var labels = cfg.labels || [];
        if (!labels.length) return;
        var cards = _allCards();
        var pdpSynth = _synthPdpCard();
        var pdpHost = pdpSynth ? _pdpBadgeHost() : null;
        // [2026-06-17] PDP onSale diagnostic console log removed — not wanted on
        // the storefront. (_logPdpOnSaleDiag left defined but unused; harmless.)
        // if (_isPdpUrl()) _logPdpOnSaleDiag(pdpSynth, labels);
        if (!cards.length && !pdpHost) return;
        var stamped = 0;
        labels.forEach(function (label) {
            if (!label || !label.enabled) return;
            cards.forEach(function (card) {
                if (_labelMatches(card, label)) {
                    if (_addBadge(card, label)) stamped++;
                }
            });
            if (pdpSynth && pdpHost && _labelMatches(pdpSynth, label)) {
                if (_stampBadgeAt(pdpHost, label)) stamped++;
            }
        });
        if (stamped > 0) _dbg(LOG_PREFIX, 'stamped', stamped, 'badge(s)');
    }

    // Two-stage config bootstrap:
    //   1. Poll for window.SE_Engine.config.acoLabeller briefly (the engine
    //      hydrates its config asynchronously after boot). If it lands,
    //      we use it.
    //   2. After ~1s of polling, kick off our own fetch of
    //      /api/aco-labeller-config in parallel -- handles the common case
    //      where the engine doesn't (yet) know about the acoLabeller
    //      sub-config and would never populate it. Either source wins; we
    //      apply as soon as one returns.
    //   3. After 3s with neither resolved, give up loudly.
    function _runWhenConfigReady() {
        var tries = 0;
        var maxTries = 15;
        var ownFetchKicked = false;
        function tick() {
            if (_config()) { _apply(); _watchMutations(); return; }
            // Kick off our own fetch once we've waited ~1s for the engine.
            if (!ownFetchKicked && tries >= 5) {
                ownFetchKicked = true;
                _fetchOwnConfig().then(function (cfg) {
                    if (cfg) { _apply(); _watchMutations(); }
                });
            }
            if (++tries >= maxTries) {
                var diag = {
                    SE_CONFIG_URL: (typeof window !== 'undefined' && window.SE_CONFIG_URL) || null,
                    engineLoaded: !!(window.SE_Engine),
                    engineConfigKeys: window.SE_Engine && window.SE_Engine.config ? Object.keys(window.SE_Engine.config) : null,
                    ownFetchKicked: ownFetchKicked,
                    cachedFallback: !!_readCachedOwnConfig()
                };
                _dbg(LOG_PREFIX, 'config not available after', tries * 200, 'ms — giving up', diag);
                return;
            }
            window.setTimeout(tick, 200);
        }
        tick();
    }

    // Collection-grid pages (filters, infinite scroll, AJAX pagination)
    // mutate the card list after first paint. A MutationObserver re-runs
    // _apply on each batch so newly-rendered cards get badged too. Debounce
    // via requestAnimationFrame to batch within a single repaint.
    function _watchMutations() {
        var queued = false;
        var observer = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var m = mutations[i];
                for (var j = 0; j < m.addedNodes.length; j++) {
                    var n = m.addedNodes[j];
                    if (n.nodeType !== 1) continue;
                    if (n.tagName === 'PRODUCT-CARD' || n.querySelector && n.querySelector('product-card')) {
                        if (!queued) {
                            queued = true;
                            requestAnimationFrame(function () { queued = false; _apply(); });
                        }
                        return;
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _runWhenConfigReady);
    } else {
        _runWhenConfigReady();
    }

    // Devtools hook for forcing a re-evaluation without page reload.
    window.__acoLabellerReapply = _apply;
})();
